module.exports = __webpack_public_path__ + "static/media/screen6.05f91a31.png";